import { useTranslation } from "../i18n";
import ProductsAdmin from "../components/ProductsAdmin";
import AdminPageHeader from "../components/admin-page-header";
import "../styles/admin-settings.css";

const AdminProducts = () => {
    const { t } = useTranslation();
    return (
        <div className="page-data page-data-wide" style={{ height: "calc(100vh - 56px)", overflow: "auto" }}>
            <AdminPageHeader
                titleKey="products_settings"
                backTo="/admin/warehouse"
                hideSearch
                crumbs={[
                    { labelKey: "admin_panel", to: "/admin" },
                    { labelKey: "warehouse_menu_title", to: "/admin/warehouse" },
                    { labelKey: "products_settings" },
                ]}
            />
            <div className="admin-settings-section">
                <p className="admin-settings-section-hint">{t("products_settings_hint")}</p>
                <ProductsAdmin />
            </div>
        </div>
    );
};

export default AdminProducts;
